export const disabledPremiumStripesBgDark = `repeating-linear-gradient(-45deg, #7A7A7A, #7A7A7A 8px, #9B9B9B 8px, #9B9B9B 16px)!important`;
export const disabledPremiumStripesBgLight = `repeating-linear-gradient(-45deg, #FFF, #FFF 8px, #E6E6E6 8px, #E6E6E6 16px)!important`;
